module.exports = __webpack_public_path__ + "static/img/14001017.1cac037a.png";